import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Link,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  CheckboxElement,
  FormContainer,
  PasswordElement,
} from "react-hook-form-mui";

import { useApiClient } from "../../api/useApiClient";
import { useSafeAsync } from "../../hooks/useSafeAsync";
import { defineStyles } from "../../styles/defineStyles";
import { AsyncButton } from "../form/AsyncButton";
import { useMinLengthValidation } from "../form/validations/useMinLengthValidation";
import { useRequiredValidation } from "../models/settings";

const LoginSetPassword: React.FC<{
  userId: number;
  token: string;
}> = (props) => {
  const styles = defineStyles({
    all: {
      width: "100vw",
      height: "100vh",
      position: "relative",
    },
    card: {
      position: "absolute",
      top: "50%",
      left: "50%",
      width: "350px",
      minHeight: "400px",
      transform: "translate(-50%,-50%)",
      p: 2,
    },
    description: {},
    descriptionBold: {
      fontWeight: "bold",
    },
    agreement: {
      mt: 2,
      mb: 2,
    },
    formGroup: {},
    textField: {
      mb: 2,
    },
    button: {
      width: "100%",
      mb: 2,
    },
    link: {
      pl: 1,
    },
  });

  const [passwordsAreSame, setPasswordsAreSame] = useState<boolean>(true);

  const required = useRequiredValidation();
  const minPasswordLength = useMinLengthValidation(8);
  const api = useApiClient();
  const [setUserPasswordCall, setUserPasswordState] = useSafeAsync(
    api.setUserPassword
  );

  const accountActivationHandler = async (data: {
    newPassword: string;
    newPasswordAgain: string;
    agreement: boolean;
  }) => {
    if (data.newPassword !== data.newPasswordAgain) {
      return setPasswordsAreSame(false);
    }
    const result = await setUserPasswordCall({
      userId: props.userId,
      token: props.token,
      password: data.newPassword,
    });
    if (typeof result === "boolean" && result) {
      window.location.href = "/";
      return setPasswordsAreSame(true);
    }
    return setPasswordsAreSame(true);
  };

  return (
    <Box sx={styles.all}>
      <Card sx={styles.card} elevation={3}>
        <CardHeader
          title="Nový účet"
          subheader={
            <React.Fragment>
              <Typography sx={styles.description} component="span">
                Aktivujte nový uživatelský účet. {/* k emailu{" "} */}
              </Typography>
              {/* <Typography sx={styles.descriptionBold} component="span">
                {props.user.email}
              </Typography>
              <Typography sx={styles.description} component="span">
                {" "}
                pod firmou{" "}
              </Typography>
              <Typography sx={styles.descriptionBold} component="span">
                TODO: Compnany Name
              </Typography> */}
              <Typography sx={styles.description} component="span">
                Tento účet vám umožní rezervovat místnosti v prostoru
                GreenTable.
              </Typography>
            </React.Fragment>
          }
        />
        <CardContent>
          <FormContainer
            defaultValues={{}}
            onSuccess={accountActivationHandler}
          >
            <PasswordElement
              name="newPassword"
              validation={{ ...required, ...minPasswordLength }}
              label="Nové heslo"
              sx={styles.textField}
            />
            <PasswordElement
              name="newPasswordAgain"
              validation={{ ...required, ...minPasswordLength }}
              label="Nové heslo znovu"
              sx={styles.textField}
            />
            {!passwordsAreSame && (
              <Typography variant="body1" color="error">
                Hesla musí být stejná.
              </Typography>
            )}
            <CheckboxElement
              name="agreement"
              validation={required}
              label={
                <React.Fragment>
                  <Typography component="span">Souhlasím </Typography>
                  <Link href="#" target="_blank">
                    s podmínkami používání
                  </Link>
                </React.Fragment>
              }
              sx={styles.agreement}
            />
            <AsyncButton
              variant="contained"
              sx={styles.button}
              state={setUserPasswordState}
            >
              Aktivovat účet
            </AsyncButton>
          </FormContainer>
        </CardContent>
        <CardActions>
          <Typography component="span" color="primary">
            Máte účet?
          </Typography>
          <Link href="/" underline="hover" sx={styles.link}>
            Přihlásit se.
          </Link>
        </CardActions>
      </Card>
    </Box>
  );
};

export default LoginSetPassword;
